import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import upload from "../../asset/upload.png";
import defaultavatar from "../../asset/defaultavatar.png";

export const useProfileStore = create(
  persist(
    (set) => ({
      profile: {
        full_name: "-",
        pektaApp: null,
        katamApp: null,
        pihtasApp: null,
        pektaUlasan: undefined,
        katamUlasan: undefined,
        pihtasUlasan: undefined,
        phone_mobile: "-",
        registration_number: "-",
        username: "-",
        gambar: defaultavatar,
        id_no: "-",
        profileRole: "TIADA",
        active: "-",
        expirydate: "-",
        isExpired: true,
        pektaexpired: "-",
        permohonan: "-",
        saringanPekta: "Menunggu...",
        saringanKatam: "Menunggu...",
        saringanPihtas: "Menunggu...",
        keputusan: "-",
        markah: "-",
        katam: "no",
        saizBaju: "",
        suratMajikan: null,
      },
      updateProfileField: (fieldName, value) => {
        set((state) => ({
          ...state,
          profile: { ...state.profile, [fieldName]: value },
        }));
      },
      resetProfile: () => {
        set(() => ({
          profile: {
            full_name: "-",
            pektaApp: null,
            katamApp: null,
            pihtasApp: null,
            phone_mobile: "-",
            registration_number: "-",
            username: "-",
            gambar: defaultavatar,
            id_no: "-",
            profileRole: "TIADA",
            active: "-",
            expirydate: "-",
            isExpired: false,
            pektaexpired: "-",
            permohonan: "-",
            saringanPekta: "Menunggu...",
            saringanKatam: "Menunggu...",
            saringanPihtas: "Menunggu...",
            keputusan: "-",
            markah: "-",
            katam: "no",
            saizBaju: "",
            suratMajikan: null,
          },
        }));
      },
    }),
    {
      name: "profile",
    }
  )
);

export const useLoginStore = create(
  persist(
    (set) => ({
      login: {
        user: "-",
        email: "-",
        username: "-",
        id: "-",
        jwtToken: null,
        alreadyShow: "-",
        havePekta: "-",
        role: null,
        pekta_application_enable: false,
        katam_application_enable: false,
        pihtas_application_enable: false,
        pektaAppStatus: null,
        katamAppStatus: null,
        pihtasAppStatus: null,
        katamEnd: "",
        katamStart: "",
        pektaID: "-",
        lastVisited: null,
      },
      updateLoginField: (fieldName, value) => {
        set((state) => ({
          ...state,
          login: { ...state.login, [fieldName]: value },
        }));
      },
      resetLoginNonAuth: () => {
        set((state) => ({
          login: {
            ...state.login,
            havePekta: "-",
            pekta_application_enable: false,
            katam_application_enable: false,
            pihtas_application_enable: false,
            pektaAppStatus: null,
            katamAppStatus: null,
            pihtasAppStatus: null,
            katamEnd: "",
            katamStart: "",
            pektaID: "-",
          },
        }));
      },
    }),
    { name: "login" }
  )
);

export const usePektaStore = create(
  persist(
    (set, get) => ({
      page: 1,
      pektaData: {
        firstName: "",
        kadPengenalan: "",
        noTel: "",
        warganegara: "",
        bangsa: "",
        tarafKahwin: "",
        alamat: "",
        bandar: "AYER BALOI",
        poskod: "82100",
        negeri: "JOHOR",
        akaunTH: "",
        akaunBank: "",
        namaBank: "",
        sektorPekerjaan: "",
        pekerjaan: "",
        jantina: "",
        umur: "",
        gambar: "",
      },
      otherPektaData: {
        noPejabat: "",
        noRumah: "",
        namaMajikan: "",
        alamatMajikan: "",
      },
      nextPage: (value) => set({ page: value }),
      updatePektaField: (fieldName, value) => {
        set((state) => ({
          pektaData: { ...state.pektaData, [fieldName]: value },
        }));
      },
      updateOtherField: (fieldName, value) => {
        set((state) => ({
          otherPektaData: { ...state.otherPektaData, [fieldName]: value },
        }));
      },
    }),
    { name: "pektadata" }
  )
);

export const useCountdownStore = create(
  persist(
    (set) => ({
      countdown: (() => {
        const savedCountdown = sessionStorage.getItem("countdown");
        const remainingTime = savedCountdown
          ? parseInt(savedCountdown, 10)
          : 2700;

        return remainingTime;
      })(),
      startTime: Date.now(),
      setCountdown: (value) => set({ countdown: value }),
      decrementCountdown: () =>
        set((state) => ({ countdown: Math.max(state.countdown - 1, 0) })),
      setPageRefreshed: (value) => set({ pageRefreshed: value }),
    }),
    { name: "pektatest", storage: createJSONStorage(() => sessionStorage) }
  )
);

export const useImageStore = create((set) => ({
  selectedImage: null,
  setSelectedImage: (image) => set(() => ({ selectedImage: image })),
  removeSelectedImage: () => set(() => ({ selectedImage: null })),
}));

export const usePengajianStore = create(
  persist(
    (set) => ({
      kelayakan: [
        {
          id: 1,
          category: "",
          type: "",
          level: "",
          institution: "",
          pengajian: "Muat naik",
          Ipengajian: upload,
          filePengajian: null,
          yearPengajian: null,
          qualificationID: null,
        },
      ],
      updatePengajianField: (index, fieldName, value) => {
        set((state) => {
          const newKelayakan = [...(state.kelayakan || [])];
          if (newKelayakan[index]) {
            newKelayakan[index] = {
              ...newKelayakan[index],
              [fieldName]: value,
            };
          }
          return {
            kelayakan: newKelayakan,
          };
        });
      },
      addQualification: () => {
        set((state) => {
          const currentKelayakan = state.kelayakan || [];
          return {
            kelayakan: [
              ...currentKelayakan,
              {
                id: currentKelayakan.length + 1,
                category: "",
                type: "",
                level: "",
                institution: "",
                pengajian: "Muat naik",
                Ipengajian: upload,
                filePengajian: null,
                yearPengajian: null,
                qualificationID: null,
              },
            ],
          };
        });
      },
      removeQualification: (index) => {
        set((state) => {
          const currentKelayakan = state.kelayakan || [];
          // Don't remove if it's the last qualification
          if (currentKelayakan.length <= 1) return state;

          return {
            kelayakan: currentKelayakan.filter((_, i) => i !== index),
          };
        });
      },
      resetQualifications: () => {
        set({
          kelayakan: [
            {
              id: 1,
              category: "",
              type: "",
              level: "",
              institution: "",
              pengajian: "Muat naik",
              Ipengajian: upload,
              filePengajian: null,
              yearPengajian: null,
              qualificationID: null,
            },
          ],
        });
      },
    }),
    {
      name: "kelayakan",
      partialize: (state) => ({
        kelayakan: state.kelayakan || [
          {
            id: 1,
            category: "",
            type: "",
            level: "",
            institution: "",
            pengajian: "Muat naik",
            Ipengajian: upload,
            filePengajian: null,
            yearPengajian: null,
            qualificationID: null,
          },
        ],
      }),
    }
  )
);
export const useTauliah = create(
  persist(
    (set) => ({
      tauliah: {
        tahunHaji: null,
        Haji: "Muat Naik",
        HHaji: "hidden",
        IHaji: upload,
        fileHaji: null,
        tarikhMula: "",
        tarikhAkhir: "",
        tauliahNegeri: "",
        fileTauliah: null,
        tauliahID: "",
        hajiID: "",
        // Mutawif related
        Mutawif: "Muat Naik",
        HMutawif: "hidden",
        IMutawif: upload,
        fileMutawif: null,
        mutawifID: "",
        kutahu: "Muat Naik",
        Hkutahu: "hidden",
        Ikutahu: upload,
        tahunSPIH: null,
        SPIH: "Muat Naik",
        HSPIH: "hidden",
        ISPIH: upload,
        fileSPIH: null,
        spihID: "",
        hajiStatus: "",
      },
      updateTauliahField: (fieldName, value) => {
        set((state) => ({
          tauliah: { ...state.tauliah, [fieldName]: value },
        }));
      },
      clearFileData: () => {
        set((state) => ({
          tauliah: {
            ...state.tauliah,
            fileHaji: null,
            fileTauliah: null,
            fileSPIH: null,
            fileMutawif: null,
          },
        }));
      },
    }),
    {
      name: "tauliah",
      partialize: (state) => ({
        tauliah: {
          ...state.tauliah,
          // Only persist non-file data
          fileHaji: null,
          fileTauliah: null,
          fileSPIH: null,
          fileMutawif: null,
        },
      }),
    }
  )
);
